<template>
    <ContentLayout>
        <div class="space-y-6">
            <!-- Header stays outside the card -->
            <header>
                <Breadcrumb :items="breadcrumbs" />
                <Heading :level="1" title="Buttons" subtitle="Preview of button components and styles." />
            </header>

            <Card>
                <CardContent class="space-y-4 rounded">
                    <section class="space-y-6 pt-6">
                        <Heading :level="2" title="Visuals" />

                        <section class="space-y-4">
                            <div>
                                <Heading
                                    :level="3"
                                    title="Variants"
                                    subtitle="The Button component supports multiple style variants."
                                />
                            </div>

                            <div class="flex flex-wrap gap-3">
                                <Button variant="default">Default</Button>
                                <Button variant="secondary">Secondary</Button>
                                <Button variant="outline">Outline</Button>
                                <Button variant="destructive">Destructive</Button>
                                <Button variant="ghost">Ghost</Button>
                                <Button variant="link">Link</Button>
                            </div>
                        </section>

                        <!-- Sizes -->
                        <section class="space-y-4">
                            <div>
                                <Heading
                                    :level="3"
                                    title="Sizes"
                                    subtitle="Buttons come in multiple sizes for different contexts."
                                />
                            </div>

                            <div class="flex flex-wrap items-center gap-3">
                                <Button size="xs">XS</Button>
                                <Button size="sm">SM</Button>
                                <Button size="default">Default</Button>
                                <Button size="lg">LG</Button>
                                <Button size="icon" aria-label="Icon">
                                    <AppIcon name="circle-info" class="h-5 w-5" />
                                </Button>
                            </div>
                        </section>
                    </section>

                    <!-- Code Section -->
                    <section class="space-y-6 pt-6">
                        <div>
                            <Heading
                                :level="2"
                                title="Code"
                                subtitle="Button Component"
                                subtitle-class="font-mono text-sm uppercase text-slate-700"
                            />
                        </div>

                        <section class="space-y-4">
                            <pre
                                class="h-96 overflow-x-auto rounded bg-gray-900 p-4 text-green-200"
                            ><code>{{ ButtonCode }}</code></pre>
                        </section>
                    </section>
                </CardContent>
            </Card>
        </div>
    </ContentLayout>
</template>

<script setup>
import { useRouter } from 'vue-router'
import Breadcrumb from '@/partials/navigation/Breadcrumb.vue'
import { ContentLayout } from '@/components/ui/layouts'
import { Heading } from '@/components/ui/typography'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import ButtonCode from '@/components/ui/button/Button.vue?raw'

const router = useRouter()

const breadcrumbs = [{ label: 'Playground', onClick: () => router.push({ name: 'playground' }) }, { label: 'Buttons' }]
</script>
